import { useEffect, useState } from "react";
import Footer from "../../Commons/Footer/Footer";
import Navigation from "../../Commons/Navigation/Navigation";
import { useParams } from "react-router";
import { Container, Spinner } from "react-bootstrap";
import { useGameContext } from "../../Commons/GameContext";

export default function CustomGameLoader() {
    const { url } = useParams();
    const [loadedGame, setLoadedGame] = useState(false)
    const [message, setMessage] = useState("")
    const { currentGame, setCurrentGame, switchGame, gameData } = useGameContext()

    function decodeURL(encoded) {
        return decodeURIComponent(atob(encoded));
    }
    
    async function fetchJSON(url) {
        const response = await fetch(url);

        if (!response.ok) {
            setMessage("Error, downloading game file at " + url + ".")
            throw new Error(`Erreur de téléchargement pour ${url}`);
        }

        const data = await response.json();

        return data
    }

    async function loadGameDataAtUrl(url) {
        const gameFileData = await fetchJSON(url)
        console.log(gameFileData)

        setLoadedGame(gameFileData)

        
        let tmp = { ...currentGame }
        let index = tmp.available.findIndex(a => a.name === gameFileData.name)
        if (index != -1) { 
            setMessage("You already have this game or a game with the same name.")
            return 
        }

        tmp.available.push({
            name: gameFileData.name,
            image: gameFileData.menuBackgroundImage,
            url: url
        })
        setCurrentGame(tmp)
        setMessage("Game has been loaded and added to your games.")
        setTimeout(() => {
            switchGame(tmp.available[tmp.available.length - 1].name)
        }, 100)
    }

    useEffect(() => {
        try {
            const gameFileUrl = decodeURL(url)
            loadGameDataAtUrl(gameFileUrl)
        } catch (error) {
            console.error('Error fetching or decoding JSON:', error);
            setMessage("Error, invalid game file URL.")
        }
    }, [])

    return (
        <div className="w-100">
            <Navigation currentPage="" />
            <Container style={{ minHeight: "85vh" }} className="d-flex flex-column below-navbar align-items-center justify-content-center">
                {!loadedGame && message == "" && (<Spinner animation="border" role="status">
                </Spinner>)}
                {loadedGame && (<h1>{loadedGame.name}</h1>)}
                <p>{message}</p>
            </Container>
            <Footer></Footer>
        </div>
    )
}